<template>
  <div>
    <div class="container">
      <b-row class="text-center profile-header mt-5">
        <b-col md="4">
          <!-- <div class="widget_box pink widget widget-alpha widget-alpha--color-amaranth"> -->
          <b-row class="widget_box pink widget widget-alpha widget-alpha--color-amaranth">
            <div class="user-caption">
              <h2>
                {{ currentUser.firstName }}
                <span>{{ currentUser.lastName }}</span>
              </h2>
              <div class="caption user-details">
                <h6>
                  <span class="fa fa-envelope-o"></span>
                  {{ currentUser.email }}
                </h6>
              </div>
              <div class="caption user-details">
                <h6>
                  <span class="fa fa-phone"></span>
                  {{ currentUser.phoneNumber }}
                </h6>
              </div>
            </div>
            <!-- <div class="button">
              <b-button variant="primary">Edit Profile</b-button>
            </div>-->
          </b-row>
        </b-col>
        <b-col md="8">
          <div class="mt-5" style="background: none;">
            <div class="content">
              <!-- <h2 class="content-heading">{{currentUser.firstName + ' ' + currentUser.lastName}}</h2> -->
              <b-row>
                <b-col
                  class="mt-5"
                  v-if="currentUser.installations&&currentUser.installations.length>0"
                >
                  <div class="pink widget widget-alpha widget-alpha--color-amaranth single_device">
                    <div class="col-md-12">
                      <h2>Installations</h2>
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Instalation Name</th>
                            <th scope="col">CID</th>
                            <th scope="col">System Capacity</th>
                            <th scope="col">System Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            :key="device.id"
                            v-for="device in currentUser.installations"
                            @click="navTo(device.id)"
                          >
                            <td>{{device.name?device.name:"Unassigned"}}</td>
                            <td>{{`${device.CID?device.CID:device.solarKitIds}`}}</td>
                            <td>{{device.deviceRequest.systemCapacity?`${device.deviceRequest.systemCapacity} kVA`:"--"}}</td>
                            <td>{{device.deviceType.name}}</td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- <div class="card-widget-j__stats" style="width: 100%;">
                  <div class="card-widget-j__stats-item">
                    <h4
                      style="font-weight: bold; border-bottom: 1px solid #eee; padding-bottom: 5px;"
                    ></h4>
                  </div>
                  <div class="card-widget-j__stats-item">
                    <p
                      class="card-widget-j__stats-value"
                      style="clear: both"
                      :key="item.id"
                      v-for="item in device.solarKitIds.split(' ')"
                    >{{item}}</p>
                  </div>
                      </div>-->
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <div class="widget_box pink widget widget-alpha widget-alpha--color-amaranth">
                    <div class="col-md-12">
                      <h2>Recent Payments</h2>
                      <ul class="device_list">
                        <can I="read" a="token">
                          <transaction-histories />
                        </can>
                      </ul>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>


<script>
/* eslint-disable */
import { Card } from "element-ui";
import { mapGetters } from "vuex";
import transactionHistories from "../shs/Wallet";
export default {
  components: {
    Card,
    transactionHistories
  },
  data() {
    return {
      currentUser: {},
      userId: 0,
      User: {
        firstName: "",
        lastName: ""
      },
      rows: []
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getDeviceByUserId",
      "getUserSession"
    ]),
    // currentUser() {
    //   let user = this.getUserById(this.userId);
    //   this.User = user;
    //   return user;
    // },
    userDevices() {
      let devices = this.getDeviceByUserId(this.userId);
      return devices;
    },
    fullname() {
      firstname = this.User.firstName === undefined ? this.User.firstName : "";
      lastname = this.User.lastName === undefined ? this.User.lastName : "";
      return firstname + " " + lastname;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    fetchUsers() {
      const HTTP = this.$utils.instance;
      const url = "/users";
      HTTP.get(url)
        .then(response => {
          this.items = usersList;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    navTo(deviceId) {
      this.$router.push({ path: `/device/${deviceId}` });
    }
  },
  mounted() {
    this.userId = this.$route.params.userId * 1;
    this.currentUser = this.getUserById(this.userId);
    // console.log(this.getUsers);
    // console.log(this.getUserById(this.userId));
    // this.fetchUsers();
  }
};
</script>
<style scoped>
.post-sec .detail {
  min-height: 25px;
  font-size: 1.2rem;
  width: 100%;
  position: relative;
  float: left;
  border-bottom: 1px solid #f6f6f6;
  padding: 12px;
  /* font-weight: bold; */
}

.card-title {
  font-size: 1.6rem;
}
#profile_id {
  /* background-image: url(/static/img/bg.png); */
  background-size: contain;
  background-color: #5c6bc0;
  /* border-color: #5c6bc0; */
  /* color: #fff; */
}
#profile_id .card-body {
  background: #ffffff !important;
}
.card-img-top {
  max-height: 20rem;
  border-radius: 12px;
}

.profile-img {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  margin-top: -230px;
}
.card-text.profile {
  text-align: left;
}

.menu_pin {
  background-image: url(/static/img/bg.png);
  background-size: contain;
  border-radius: 7px;
  cursor: pointer;
  /* color: #ffffff; */
  background: #fff;
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  margin-bottom: 1.875rem;
  padding: 0;
  /* border: #5c6bc0 1px solid ; */
  /* height: 120px; */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  /* -webkit-box-align: center;
-ms-flex-align: center;
align-items: center; */
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
  width: 100%;
  min-height: 200px;
}

.btn-icon {
  font-size: 4rem;
  /* color: #5c6bc0; */
}
.detail .btn-icon {
  font-size: 1.2rem;
  color: rgb(70, 70, 70);
  margin-right: 20px;
  float: left;
}

.widget-beta__desc {
  font-size: 2rem;
}
.card-body h4 {
  /* text-align: left; */
  border-bottom: 1px solid #eee;
  font-weight: 400;
  font-size: 1.2em;
  padding: 10px;
}

.single_device:hover {
  /* transform: scale(1.002); */
}

.single_device {
  /* font-weight: 500;
  padding: 10px;
  margin: 10px;
  list-style: none;
  text-align: left;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  padding-left: 2%;
   */
  cursor: pointer;
}

.device_list {
  padding: 0px;
}
h2 {
  text-align: left;
}
.widget_box {
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  border: none !important;
}

div.profile-header.col,
.container-fluid {
  padding: 0 !important;
  margin: 0 !important;
  /* }

 { */
  /* position: relative; */
  /* overflow: hidden; */
  /* margin: 10px auto; */
  /* min-width: ;
  max-width: 400px; */
  /* min-width: 100% !important; */
  /* background: #000000; */
  /* color: #333; */
  /* text-align: left; */
  /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.15); */
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  /* margin-left: auto;
  margin-right: auto; */
  /* display: flex;
  flex-flow: row; */
}
/* * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.35s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  transition: all 0.35s cubic-bezier(0.25, 0.5, 0.5, 0.9);
} */
.profile_img {
  width: auto;
  height: 80px;
  border-radius: 50%;
  /* padding: 20px 20px; */
  margin: 30px 30px;
}
div.button button {
  margin-top: 30px;
  position: absolute;
  right: 20px;
  /* background-color: #fff !important;
  border-color: #fff !important; */
  color: #6a707e !important;
  box-shadow: 0 4px 10px rgba(16, 156, 241, 0.24);
  padding: 0.04px 32px !important;
  font-size: 12px !important;
}
/* div.button button:hover {
  background-color:  #ccc !important;
  color: #fff !important;
} */
.user-caption {
  display: flex;
  flex-flow: column;
  padding: 30px 20px;
  text-align: center;
  /* color: #fff; */
  margin-bottom: 20px;
}
.user-caption h2 {
  font-weight: bold !important;
}
.user-caption div.caption h6 {
  font-size: 12px;
  font-weight: bold;
}
.user-caption div.caption h6 span,
.user-caption div.user-details h6 {
  display: flex !important;
  flex-flow: row !important;
}

.user-caption div.caption h6 span {
  margin-right: 10px !important;
}
h3 {
  position: absolute;
  bottom: 100%;
  text-transform: uppercase;
  padding: 10px 25px;
  border-radius: 0 5px 0 0;
  margin: 0;
  left: 0;
  font-weight: 400;
  background-color: #000000;
  color: #ffffff;
}
h3 span {
  font-weight: 800;
}
/* p {
  font-size: 0.8em;
  font-weight: 500;
  text-align: left;
  margin: 0;
  line-height: 1.6em;
} */
/* .icons {
  position: absolute;
  bottom: 0;
  right: 25px;
} */
/* i {
  margin: 0 2px;
  display: inline-block;
  font-size: 20px;
  color: #ffffff;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #000000;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  border-radius: 5px 5px 0 0;
} */
/* i:hover {
  background-color: #000000;
  color: white !important;
}
a {
  opacity: 0.8;
  display: inline-block;
}
a:hover {
  opacity: 1;
}
div.profile_box.blue {
  background-color: #2472a4;
}
div.profile_box.blue figcaption:after,
div.profile_box.blue h3,
div.profile_box.blue i {
  background-color: #2472a4;
}
div.profile_box.red {
  background-color: #ab3326;
}
div.profile_box.red figcaption:after,
div.profile_box.red h3,
div.profile_box.red i {
  background-color: #ab3326;
}
div.profile_box.green {
  background-color: #229955;
}
div.profile_box.green figcaption:after,
div.profile_box.green h3,
div.profile_box.green i {
  background-color: #229955;
}
div.profile_box.orange {
  background-color: #d67118;
}
div.profile_box.orange figcaption:after,
div.profile_box.orange h3,
div.profile_box.orange i {
  background-color: #d67118;
}
div.profile_box.navy {
  background-color: #2b3c4e;
}
div.profile_box.navy figcaption:after,
div.profile_box.navy h3,
div.profile_box.navy i {
  background-color: #2b3c4e;
} */
/* div.profile_box:hover img,
div.profile_box.hover img {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/users/details.vue